import {MenuItem} from "@mui/material";
import Text from "../../components/Text";
import Spinner from "../../components/Spinner";
import Dropdown from "../../components/Dropdown";
import SearchBox from "../../components/SearchBox";
import { Col, Row } from "../../components/Flexbox";
import FilterBar from "../../components/FilterBar";
import BonusTable from "../../components/BonusTable";
import MachineTable from "../../components/MachineTable";
import ModifyResources from "../../components/ModifyResources";
import JobtrackBar from "../../components/JobtrackBar";
import DateButtons from "../../components/DateButtons";
import { useTheme } from "../../scripts/functions/ThemeProvider";
import SelectableContainer from "../../components/SelectableContainer";

import {format} from 'date-fns';
import {useState, useEffect, useRef} from "react";
import { loadFromStorage, useSaveToStorage } from "../../utils";
import exportToCSV from "../../utils/ExportExcel";
import { authorizedGet } from "../../scripts/functions/AuthService";
import { useMachineNormalizer } from "../../containers/MachineNormalizer";
import { useJobtrackNormalizer } from "../../containers/JobtrackNormalizer";

const Jobtrack = () => {
    const {theme} = useTheme();     
    const persisted = loadFromStorage('JOBTRACK_FILTERS') || {};
    const [reports, setReports] = useState([]);
    const [isLoading, setIsLoading] = useState(true);   //The component fetches data from the beginning
    const [selections, setSelections] = useState( persisted.selections || {
        type: 'Eficiencia',
        resource: 'NomeOperador',
    });
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const [processedBars, setProcessedBars] = useState([]);
    const [view, setView] = useState(persisted.view || 'default');
    const isBonusActive = view === 'bonus';
    const isMachineActive = view === 'machine';
    const {table, loading, search, isSaving, percentages, statusFilter, uniqueResources, uniqueStatuses, fetchBonusData, fetchPercentages, savePercentages, getBonusDate, setSearch, exportCSV, setStatusFilter, uploadRoleFile, previousWeek, setPreviousWeek} = useJobtrackNormalizer(theme);
    const roleFileRef = useRef(null);
    const {table: machineTable, loading: machineLoading, search: machineSearch, fetchMachineData, setSearch: setMachineSearch, exportCSV: exportMachineCSV} = useMachineNormalizer(theme);
    //Gets the value of the MenuItem
    const handleDropdown = (name, value) => {   
        setSelections(current => ({
            ...current, [name]: value,
        }));
    };

    //Sets current day as a default value for the container
    const currentDate = () => { 
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        const dateFormat= 'MM/dd/yyyy';
        return {
            type: 'Hoy',
            startDate: format(today, dateFormat),
            endDate: format(today, dateFormat),
            formattedDate: format(today, 'dd MMM yyyy')
        }
    };

    const [date, setDate] = useState(persisted.date || currentDate());
    const [selectedBar, setSelectedBar] = useState(persisted.selectedBar || null);

    useSaveToStorage('JOBTRACK_FILTERS', {selections, date, selectedBar})

    const getReports = async (date, selections) => {
        try {
            //console.log("Fetching reports");

            //Parameters needed for the data filter
            const startDate = encodeURIComponent(date.startDate.replaceAll("/", "-"));
            const endDate = encodeURIComponent(date.endDate.replaceAll("/", "-"));
            const column = encodeURIComponent(selections.resource);
            const response = await authorizedGet(`/jobtrack/getReports/${startDate}/${endDate}/${column}`)
            const resData = await response.body.json()
            
            setReports(resData);
            if(!resData || resData.length === 0) {
                setProcessedBars([]);
            }
            // console.log(resData);
        } catch(error) {
            console.error("Error al obtener los reportes: ", error);
        } finally {
            setIsLoading(false);    //Call ended
        }
    };

    useEffect(() => {
        if(selections.resource && selections.type) {
            setIsLoading(true);
            getReports(date, selections);
        } else {
            setIsLoading(false);    //getReports won't be called
        }
    }, [date, selections]);

    const handleSelection = (period) => {
        setDate(period);
    };

    const handleBonus = () => {
        setView(isBonusActive ? 'default' : 'bonus');
        fetchBonusData();
        fetchPercentages();
    }

    const handleSaveResources = (payload) => {
        savePercentages(payload, {
            onSuccess: () => setIsPopupOpen(false)
        })
    }

    const handleMachine = () => {
        setView(isMachineActive ? 'default' : 'machine');
        fetchMachineData();
    }

    const exportJobtrackCSV = () => {
        const resourceLabel = selections.resource === 'NomeOperador' ? 'Operador' : 'Recurso';
        const typeLabels = {
            EfArreglo: 'Eficiencia en tiempo de arreglo',
            Eficiencia: 'Eficiencia en tiempo de producción',
            EfTotal: 'Eficiencia total',
        };
        const rows = [
            ['Tipo', typeLabels[selections.type] || selections.type],
            [resourceLabel, 'Porcentaje'],
            ...processedBars.map(bar => [bar.label, bar.originalValue]),
        ];
        exportToCSV(`Jobtrack_${date.formattedDate.replace(/\s+/g, "_")}.xlsx`, rows);
    }

    return (
        <Col style={{minWidth: '100%', height: 552.67, top: 235, left: 65, justifyContent: 'start', marginTop: 60, overflow: 'hidden'}} mobileStyle={{width: '100%', maxWidth: '100%'}}>
            <Text weight="bold" size={27} color={theme.ONED} style={{width: '90%', height: 34, textAlign: 'left'}}>Jobtrack</Text>
            <FilterBar style={{width: '90%', maxHeight: 36, alignItems:'center', paddingTop: 50, paddingBottom: 20}}>
                <DateButtons key={date.type} disabled={isBonusActive || isMachineActive} theme={theme} onDateSelect={handleSelection} initialType={date.type}/>
                <Text size={30} style={{justifyContent: 'left', marginBottom: '12px', marginLeft: '-8px'}}>│</Text>
                <SelectableContainer theme={theme} text="Bonos" active = {isBonusActive} onClick = {() => handleBonus()}></SelectableContainer>
                {/* <SelectableContainer theme={theme} text="Máquinas" active = {isMachineActive} onClick = {() => handleMachine()}></SelectableContainer>  */}
                <div style={{marginLeft: 'auto', height: '36px'}}><Text color={theme.Magenta} style={{width: '5%', textAlign: 'right', alignItems:'center'}}>{isBonusActive ? getBonusDate() : date.formattedDate}</Text></div>
            </FilterBar>
            <Row style={{width: '90%', gap: 16, alignItems: 'start', justifyContent: 'start', paddingTop: 30, paddingBottom: 0, flex: 'none'}}>
                {view === 'default' ? (
                    <FilterBar style={{width: '100%', height: 36, gap: 16, justifyContent: 'start', alignItems: 'start'}}>
                        <Dropdown theme={theme}  value={selections.type} onChange={(value) => handleDropdown('type', value)} style={{width: 342, height: 36}}>
                            <MenuItem value = "EfArreglo">Eficiencia en tiempo de arreglo</MenuItem>
                            <MenuItem value = "Eficiencia">Eficiencia en tiempo de producción</MenuItem>
                            <MenuItem value = "EfTotal">Eficiencia total</MenuItem>
                        </Dropdown>
                        <Dropdown theme={theme}  value={selections.resource} onChange={(value) => handleDropdown('resource', value)} style={{width: 342, height: 36}}>
                            <MenuItem value = "CodRecurso">Por recurso</MenuItem>
                            <MenuItem value = "NomeOperador">Por operador</MenuItem>
                        </Dropdown>
                        <Row style={{flex: 'none', maxHeight: '36px', height: '36px'}}>
                            <Text style={{ cursor:'pointer', transition:'transform 2s ease'}} onClick={exportJobtrackCSV} color={theme.Magenta} size={15}>Exportar a Excel</Text>
                        </Row>
                    </FilterBar>
                ) : isBonusActive ? (
                    <FilterBar style={{width: '100%', height: 36, gap: 16, justifyContent: 'start', alignItems: 'center', marginBottom: '8px'}}>
                        <Row style={{flex: 1, justifyContent: 'flex-start',maxHeight: '36px', gap: 16}}>
                            <SearchBox theme={theme} style={{width: 'auto', flex: 'none', height: 36}} placeholder="Nómina, nombre o recurso" value = {search} onChange={setSearch}></SearchBox>
                            <Dropdown theme={theme} placeholder="Estado" value={statusFilter} onChange={setStatusFilter} style={{width: '342px', height: '36px'}}>
                                <MenuItem value="">Todos los estados</MenuItem>
                                    {uniqueStatuses.length > 0 && uniqueStatuses.map(s => (
                                        <MenuItem key={s} value={s}>{s}</MenuItem>
                                    ))}
                                <MenuItem value="__empty__">Sin estado</MenuItem>
                            </Dropdown>
                            <SelectableContainer theme={theme} text="Semana anterior" active={previousWeek} onClick={() => setPreviousWeek(!previousWeek)} style={{marginBottom: 0}}/>
                        </Row>
                        <Row style={{flex: '.2', alignItems: 'space-between', justifyContent: 'space-between', maxHeight: '36px', gap: 16}}>
                            <Text style={{ whiteSpace: 'nowrap', cursor: 'pointer'}} onClick={() => roleFileRef.current?.click()} color={theme.Magenta}>Subir rol</Text>
                            {/* The value is cleared so the same file can be picked again after fixing it */}
                            <input ref={roleFileRef} type="file" accept=".xlsx" style={{display: 'none'}} onChange={(e) => { uploadRoleFile(e.target.files?.[0]); e.target.value = ''; }}/>
                            <Text style={{ whiteSpace: 'nowrap', cursor: 'pointer'}} onClick={() => setIsPopupOpen(true)} color={theme.Magenta}>Modificar recursos</Text>
                            <Text style={{ whiteSpace: 'nowrap', cursor:'pointer', transition:'transform 2s ease'}} onClick={exportCSV} color={theme.Magenta}  size={15}>Exportar a Excel</Text>
                        </Row>
                    </FilterBar>
                ) : (
                    <FilterBar style={{width: '100%', height: 36, gap: 16, justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px'}}>
                        <SearchBox theme={theme} style={{width: 'auto', flex: 'none', height: 36}} placeholder="Nombre de máquina" value = {machineSearch} onChange={setMachineSearch}></SearchBox>
                        {/* <Text style={{ cursor:'pointer', transition:'transform 2s ease'}} onClick={exportMachineCSV} color={theme.Magenta}  size={15}>Exportar a Excel</Text> */}
                    </FilterBar>
                )}
            </Row>
            {
                (isLoading || (isBonusActive && loading) || (isMachineActive && machineLoading))
                ?
                <Col style={{justifyContent: 'center', alignItems: 'center', minHeight: 500, width:'100%'}}>
                    <Spinner theme={theme}/>
                </Col>
                :
                <Row style={{width: '90%', maxWidth: '100%', minWidth: 0, minHeight: 0, overflowY: (isBonusActive || isMachineActive) ? 'hidden' : 'auto', overflowX: 'hidden', flex: 1, alignItems: 'start', justifyContent: 'start', paddingTop: 5}}>
                    {isBonusActive ? (
                        <BonusTable table={table} theme={theme}/>
                    ) : isMachineActive ? (
                        <MachineTable table={machineTable} theme={theme}/>
                    ) : (
                        reports.length > 0 && (
                            <JobtrackBar date={date} theme={theme} data={reports} selection={selections} selectedBar={selectedBar} onClick={setSelectedBar} onDataReady={setProcessedBars}></JobtrackBar>
                        )
                    )}
                </Row>
            }
            {isPopupOpen && (
                <ModifyResources resources={uniqueResources} theme={theme} onClose={() => setIsPopupOpen(false)} onSave={handleSaveResources} isLoading={isSaving} percentages={percentages}/>
            )}
        </Col>
    )
}

export default Jobtrack;
